/**
 * In-memory dashboard cache — avoids refetching on tab switch
 * TTL: 90 seconds per key
 */
const CACHE = {};
const TTL = 90_000; // 90s

export function getCached(key) {
  const entry = CACHE[key];
  if (!entry) return null;
  if (Date.now() - entry.ts > TTL) { delete CACHE[key]; return null; }
  return entry.data;
}

export function setCached(key, data) {
  CACHE[key] = { data, ts: Date.now() };
}

export function invalidateCache(key) {
  delete CACHE[key];
}
